<div *ngIf="!loader" (scroll)="onScroll($event)"
  [ngStyle]="OpenOnInitDialog ? {'overflow': 'hidden'}:{'overflow': 'auto'}"
  class="h-full flex flex-col bg-gradient-to-t from-stone-100 to-white">

  <app-header-order [redirectPage]="'product'"></app-header-order>

  <!-- Banner point of sale -->
  <div>

    <div [ngClass]="cssService.cardClass" class="banner-pos" ngClass.lt-md="banner-pos-md" ngClass.xs="banner-pos-xs"
      [ngStyle]="{
        'background-image':
          'url(' +
          (currPos && currPos.banner
            ? (currPos.banner | prodSizeFilter: 1920)
            : currPos.banner_original) +
          ')'
      }"></div>

  </div>

  <!-- Main comp -->
  <div class="flex items-center justify-center flex-1" #main_container>

    <!-- Comp 1279px -->
    <div class="flex flex-row w-[1200px] h-full lg:w-[1200px] w-full">

      <div class="flex-1">

        <!-- Logo and point of sale info -->
        <div [ngClass]="cssService.sectionCardClass" class="mb-4 mt-4 mx-4 xl:-mt-8 xl:mx-0">

          <div class="flex flex-row gap-6">

            <div *ngIf="currPos.img" class="hidden md:block">
              <img [ngClass]="cssService.posImageClass" src="{{ currPos.img }}" alt="{{ currPos.denomination }}" />
            </div>

            <div class="flex flex-col">

              <!-- Point de vente -->
              <div class="mb-4">
                <span class="text-lg sm:text-2xl text-gray-800 uppercase font-bold fontPoppins">{{ currPos.denomination
                  }}</span>
              </div>

              <!-- Coordonnées-->
              <div class="flex flex-col">

                <!-- Adresse-->
                <div class="flex justify-start items-center mb-1 text-sm" class="text-sm text-gray-800 font-semibold">
                  <i class="material-icons text-indigo-500 mr-2">location_on</i>
                  <div>
                    <span>{{ currPos.address | uppercase }} -
                      {{ currPos.postal }}
                      {{ currPos.city | uppercase }}</span>
                  </div>
                </div>

                <!-- Téléphone-->
                <div class="flex flex-row justify-start items-center mb-2 text-sm"
                  class="text-sm text-gray-800 font-semibold">
                  <i class="material-icons text-indigo-500 mr-2">phone</i>
                  <span *ngIf="currPos.phone_2">{{ currPos.phone_2 }}&nbsp;&nbsp;</span>
                  <span *ngIf="currPos.phone">{{ currPos.phone }}</span>
                </div>

              </div>

              <!-- Bouton Horaires-->
              <app-fulle-thumbnail-shedules class="mt-2" *ngIf="currSM.enable_date_hour" [sale_method]="currSM"
                [point_of_sale]="currPos" [isBlock]="true">
              </app-fulle-thumbnail-shedules>
            </div>

          </div>
        </div>

        <!-- Infos order currSM.description_order -->
        <app-order-info-thumbnail *ngIf="currSM.description_order" class="px-4">
        </app-order-info-thumbnail>

        <!-- Change salemethod and product hour -->
        <div fxHide fxShow.lt-lg fxLayout="column" style="padding: 10px">

          <div fxLayout="row" fxLayoutAlign="space-between center" class="layout-padd divider divider-top"
            style="padding: 10px">
            <span class="mat-subheading-1">{{ currSM.name | uppercase }}</span>


            <span class="mat-subheading-1 primary-ico boldest clicked"
              *ngIf="( !currSM.disable_authentification  ||currSM.disable_authentification !==1 )&& currSM.webshop_visible"
              [class.isDisabled]="(currSM.onlyOneSM && !currSM.bookingActive) " (click)="openSMDial(currSM.id)"
              angulartics2On="click" angularticsAction="openSaleMethodsDialog"
              angularticsCategory="headers">{{"button.modify"|translate}}</span>

          </div>

          <div fxLayout="row" fxLayoutAlign="space-between center" class="layout-padd divider" style="padding: 10px"
            *ngIf="currSM.enable_date_hour ">
            <span class="mat-subheading-1" *ngIf="orderDateHour.day">{{ orderDateHour.day | dateFilter: "ddd DD/MM" }}
              <span *ngIf="orderDateHour.hour"> - {{ orderDateHour.hour | dateFilter: "HH:mm" }}</span></span>

            <span class="mat-subheading-1 primary-ico boldest clicked" (click)="openSelectProductsTimeSlotDial()"
              angulartics2On="click" angularticsAction="openProductsSlotSelectorDial"
              angularticsCategory="headers">{{"button.modify"|translate}}</span>
          </div>
        </div>

        <!-- Products list  -->
        <div #Prodrubs>

          <div fxFlex fxLayout="column" fxLayoutGap="10px" [ngStyle.lt-lg]="{ padding: '0 10px 0px 10px' }">

            <!-- Rubriques -->

            <div fxLayout="column" fxLayoutGap="5px" class="full-w" *ngIf="rubrics$ && rubrics$.length > 0" #rubsComp>

              <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px">

                <div>
                </div>

                <div fxLayout="row" fxLayoutGap="5px">

                  <div fxLayoutAlign="center center" style="padding: 5px;" (click)="scrollRubList('+')"
                    *ngIf="sliderRubArrowLeft">
                    <i class="fas fa-arrow-left clicked primary-ico" style="font-size: 20px;"></i>
                  </div>

                  <div fxLayoutAlign="center center" style="padding: 5px;" *ngIf="sliderRubArrowRight"
                    (click)="scrollRubList('-')">
                    <i class="fas fa-arrow-right clicked primary-ico" style="font-size: 20px;"></i>
                  </div>

                  <div fxLayoutAlign="center center" class="rad-bord" style="padding: 5px;"
                    *ngIf="!sliderRubArrowRight">
                    <div style="height: 21px; width:17.5px;"></div>
                  </div>

                </div>

              </div>

              <!-- Unfixed rubs -->
              <div class="rubs-comp-slide invisible-scroll-bar" id="listRubrics" #listRubrics>

                <div class="flex flex-row gap-2 rub-list" #rubsList>

                  <app-rubric-item-list *ngFor="let rub of displayRubrics;" (onRubricSelected)="findRub($event)"
                    [rub]="rub"></app-rubric-item-list>

                </div>

              </div>

              <!-- Fixed rubs -->
              <div class="fixed-sliding-rubs" ngClass.lt-lg="full-w fixed-sliding-rubs-resp" *ngIf="!toggleRubBar"
                #ProdrubsFixed>

                <!-- Arrows  -->
                <div fxLayout="row" fxLayoutAlign="space-between center" class="full-screen"
                  style="position: absolute;padding-left: 10px; padding-right: 14px;height: 50px;">

                  <div fxLayoutAlign="center center" class="text-indigo-500 rounded-full p-2 bg-gray-200 shadow"
                    style="z-index: 99;" (click)="scrollRubListFixed('+')">
                    <i class="fas fa-arrow-left clicked" style="font-size: 20px;"></i>
                  </div>

                  <div fxLayoutAlign="center center" class="text-indigo-500 rounded-full p-2 bg-gray-200 shadow"
                    style="z-index: 99;" (click)="scrollRubListFixed('-')">
                    <i class="fas fa-arrow-right clicked primary-ico" style="z-index: 99; font-size: 20px;"></i>
                  </div>

                </div>

                <!-- Content -->
                <div class="flex items-center full-w rubs-comp-slide invisible-scroll-bar" id="listRubricsFixed"
                  #listRubricsFixed>

                  <div class="flex flex-row items-center justify-start gap-[10px] rub-list mx-12" #rubsListFixed>

                    <app-rubric-item-list *ngFor="let rub of displayRubrics;" (onRubricSelected)="findRub($event)"
                      [rub]="rub"></app-rubric-item-list>

                  </div>

                </div>

              </div>

            </div>

            <!-- Search input -->

            <div fxLayout="column" fxLayoutGap="5px" class="full-w" fxHide.lt-lg>

              <div>
                <form [formGroup]="searchProductForm" fxLayoutAlign="space-between
                      center" fxLayoutGap="10px">
                  <mat-form-field appearance="outline" fxFlex class="form-nopadd">
                    <input type="text" matInput placeholder="{{'searchProdPlaceholder'|translate}}"
                      formControlName="searchProductInput" fxFlex />
                    <mat-icon matSuffix *ngIf="!searchProductForm.get('searchProductInput').value">search</mat-icon>
                    <mat-icon *ngIf="searchProductForm.get('searchProductInput').value" matSuffix class="clicked"
                      (click)="
                    resetSearchProduct()
                    ">close
                    </mat-icon>
                  </mat-form-field>
                </form>
                <mat-progress-bar mode="buffer" *ngIf="searchProductLoader"></mat-progress-bar>
              </div>

            </div>

            <!-- Finded prod list -->
            <app-finded-prods-list id="searchproductrub" *ngIf="!searchProductLoader && findedProducts"
              (openProdDialEvent)="openProdDial($event, 'add')" [pointOfsale]="currPos"
              [merchantClient$]="merchantClient" [findedProducts]="findedProducts" fxLayout="column"
              [class.moremarg]="!toggleRubBar && windowWidth < 1279  "></app-finded-prods-list>

            <!-- Rub - prod list  -->
            <app-rub-prod-list [class.moremarg]="!toggleRubBar && !findedProducts && windowWidth < 1279" #rubProdCont
              (openProdDialEvent)="openProdDial($event, 'add')" [rubrics$]="rubrics$" [products$]="products$"
              [newRubricsDisplay$]="newRubricsDisplay$" [pointOfsale]="currPos" [merchantClient$]="merchantClient"
              [user_]="user_" (deconnectionEvent)="deconnection()" (moreProductsEvent)="moreProducts($event)"
              [loaderpop]="loaderpop" [count]="$count" [more_products_button]="$more_products_button"
              [limit_from]="$limit_from" [scrollingElementProd]="scrollingElementProd" fxLayout="column"
              fxLayoutGap="20px" style="min-height: 65vh;" [ngStyle.gt-md]="{'min-height': '55vh'}">
            </app-rub-prod-list>

            <!-- Pied de page -->
            <app-footer-client class="w-full"></app-footer-client>

          </div>

        </div>

      </div>

      <!-- basket -->
      <div class="w-[300px] relative hidden xl:block">

        <div #basketComp>

          <app-basket-product ngClass.gt-md="absolute-basket" [class.fixed-sliding-basket]="!toggleBasket"
            [categories$]="categories$" [products$]="products$" [displayDay]="displayDay" [displayHour]="displayHour"
            [orderDateHour]="orderDateHour" (openSmDial)="openSMDial($event)"
            (openSelectProductsTimeSlotDialEvent)="openSelectProductsTimeSlotDial($event)"
            [merchantClient$]="merchantClient" [webshop_visible]="currSM.webshop_visible"></app-basket-product>
        </div>

      </div>

      <!-- basket resp -->
      <app-basket-product class="absolute-basket-resp block xl:hidden" [class.show-basket-resp]="!toggleBasketResp"
        [categories$]="categories$" [products$]="products$" [displayDay]="displayDay" [displayHour]="displayHour"
        [orderDateHour]="orderDateHour" (closeBasketEvent)="closeBasket()" (openSmDial)="openSMDial($event)"
        (openSelectProductsTimeSlotDialEvent)="
          openSelectProductsTimeSlotDial($event)" [merchantClient$]="merchantClient"></app-basket-product>

    </div>

  </div>

  <app-handle-sidenav class="block xl:hidden" [products$]="products$" [searchProductLoader]="searchProductLoader"
    [showSearchInput]="showSearchInput" [toggleBasket]="toggleBasketResp"
    (setShowSearchInputEvent)="setShowSearchInput($event)" (setFindedProductsEvent)="setFindedProducts($event)"
    (setSearchProductLoaderEvent)="setSearchProductLoader($event)" (openBasketEvent)="openBasket()"
    [merchantClient$]="merchantClient" (resetSearchProductEvent)="resetSearchProduct()"
    (searchProductEvent)="searchProduct($event) " [closeSearch]="closeSearch">

  </app-handle-sidenav>

</div>

<app-fulle-page-loader [loader]="loader" [pointOfSale]="currPos" fxFlexFill>
</app-fulle-page-loader>

<app-popup-loader [flagLoading]="loaderpop" [size]="30" [statusMessage]="statusMessage"
  [transparent]="loaderTransparent">
</app-popup-loader>